import { FC } from 'react';
import { ReactComponent as BonesIcon } from '@app/assets/icons/bones.svg';
import { ReactComponent as FatIcon } from '@app/assets/icons/fat.svg';
import { ReactComponent as ProteinIcon } from '@app/assets/icons/protein.svg';
import { ReactComponent as WaterBalanceIcon } from '@app/assets/icons/water.svg';

export type StatisticColor = 'primary' | 'error' | 'secondary' | 'success';

interface ConfigStatistic {
  id: number;
  name: string;
  title: string;
  color: StatisticColor;
  Icon: FC;
}

export const statistics: ConfigStatistic[] = [
  {
    id: 1,
    name: 'item 1',
    title: 'medical-dashboard.protein',
    color: 'success',
    Icon: ProteinIcon,
  },
  {
    id: 2,
    name: 'item 2',
    title: 'medical-dashboard.fat',
    color: 'error',
    Icon: FatIcon,
  },
  {
    id: 3,
    name: 'item 3',
    title: 'medical-dashboard.bones',
    color: 'primary',
    Icon: BonesIcon,
  },
  {
    id: 4,
    name: 'item 4',
    title: 'medical-dashboard.water',
    color: 'secondary',
    Icon: WaterBalanceIcon,
  },
];
